import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

export default function Footer() {
  const { t } = useLanguage();
  
  return (
    <footer className="bg-brand-dark border-t border-gray-800 pt-16 pb-8 text-center md:text-left">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-8 mb-12">
        <div>
          <h3 className="text-2xl font-bold text-white mb-4 tracking-tighter">Izzi<span className="text-blue-400">SEO</span></h3>
          <p className="text-gray-400 text-sm leading-relaxed">
            Premium web development and SEO services tailored for modern businesses looking to scale.
          </p>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4">Quick Links</h4>
          <ul className="space-y-2 text-sm text-gray-400">
            <li><a href="#services" className="hover:text-blue-400 transition-colors">{t('nav.services')}</a></li>
            <li><a href="#team" className="hover:text-blue-400 transition-colors">{t('nav.team')}</a></li>
            <li><a href="#pricing" className="hover:text-blue-400 transition-colors">{t('nav.pricing')}</a></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4">Legal</h4>
          <ul className="space-y-2 text-sm text-gray-400">
            <li><a href="#" className="hover:text-blue-400 transition-colors">{t('footer.terms')}</a></li>
            <li><a href="#" className="hover:text-blue-400 transition-colors">{t('footer.cookies')}</a></li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500">
        <p>&copy; {new Date().getFullYear()} IzziSEO. {t('footer.rights')}</p>
      </div>
    </footer>
  );
}